import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from './api';

const DEFAULT = {
  importance_display: 'background',
  default_list_id: null,
  show_next_7_days: true,
  show_this_week: false,
  show_this_month: false,
  show_later: false,
  completion_animation: true,
  completion_sound: true,
  show_tags: false,
  show_incomplete_bin: true,
  show_deleted_bin: false,
};

const Ctx = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULT);

  useEffect(() => {
    api.get('/settings').then(r => setSettings({ ...DEFAULT, ...r.data })).catch((e) => console.warn('Settings load failed:', e.message));
  }, []);

  const updateSettings = useCallback(async (updates) => {
    setSettings(prev => {
      const next = { ...prev, ...updates };
      api.put('/settings', next).catch((e) => console.warn('Settings save failed:', e.message));
      return next;
    });
  }, []);

  return <Ctx.Provider value={{ settings, updateSettings }}>{children}</Ctx.Provider>;
}

export function useSettings() {
  const ctx = useContext(Ctx);
  if (!ctx) return { settings: DEFAULT, updateSettings: () => {} };
  return ctx;
}
